import React from 'react';

import WsIconProps from './IconProps';

const BlackDot: React.FC<WsIconProps> = ({ color = '#11151C', width = 16, height = 16 }) => (
  <svg
    width={width}
    height={height}
    viewBox={`0 0 ${width} ${height}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 4C0 1.79086 1.79086 0 4 0H12C14.2091 0 16 1.79086 16 4V12C16 14.2091 14.2091 16 12 16H4C1.79086 16 0 14.2091 0 12V4Z"
      fill="white"
    />
    <circle cx="8" cy="8" r="3" fill={color} />
  </svg>
);

export default BlackDot;
